$(window).on('load',function(){
    if($('#mailchimp-form').length > 0){
        $('#mailchimp-form').css('display','block');

        $('#mailchimp-form').formValidation({
            plugins: {
                autoFocus: new FormValidation.plugins.AutoFocus(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                declarative: new FormValidation.plugins.Declarative({
                    html5Input: true,
                }),
                trigger: new FormValidation.plugins.Trigger({
                    event: 'change keyup input',
                    threshold: 3,
                    delay: 1,
                }),
                //excluded: new FormValidation.plugins.Excluded({}),
                message: new FormValidation.plugins.Message({
                    clazz: 'error',
                    container:function (field,element) {
                        return $(element).parent().get(0);
                    }
                }),
            },
        });
        $('#mailchimp-form').data('formValidation').on('core.element.validated',function (event) {
            if(event.valid === true){
                $(event.element).parent().toggleClass('invalid')
            }else{
                $(event.element).parent().toggleClass('invalid')
            }
        });
    }
});
